import usePlugins from './usePlugins'
import startAjax from './startAjax'
// import env from '@/api/api.env.js'
// import {
//     addWeixinSdk
// } from '../../utils/wxsdk'
// import { addTXMapSDK } from './addTXMapSDK'
// import { addGdMap } from './addGDMAP'
// import {
//     addAliVideoSdk
// } from '@/utils/aliyun'
// import {
//     addBaiduStatistics
// } from './addBaiduStatistics'
export default Vue => {
    usePlugins(Vue)
    startAjax()
    // addTXMapSDK(Vue)
    // addGdMap(Vue)
    // JSON.parse(env) === 'release' && addBaiduStatistics()
    // addWeixinSdk()
}
